import { Check } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * The numbered step marker on the production-path rail — filled with a tick once
 * the step has produced its artifact, ringed while it is the active step.
 * (Named for the sprocket holes on a film strip, matching the rail's motif.)
 */
export default function Sprocket({
  index,
  state,
  className,
}: {
  /** 1-based position shown when the step is not yet done. */
  index: number;
  state: 'done' | 'active' | 'pending';
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full border-2',
        'font-mono text-[10px] leading-none transition-colors',
        state === 'done' && 'border-primary bg-primary font-bold text-primary-foreground',
        state === 'active' && 'border-primary bg-elevated text-primary ring-[3px] ring-primary/15',
        state === 'pending' && 'border-track bg-elevated text-faint',
        className,
      )}
    >
      {state === 'done' ? <Check className="h-3 w-3" strokeWidth={3} /> : index}
    </span>
  );
}
